import { ScheduledDelivery } from '../../shared/types/ScheduledDelivery'
import { ScheduledDeliveryEntity } from '../../domain/entities/ScheduledDelivery'

export type ScheduledDeliveryAPIModel = ScheduledDelivery

export const mapApiToEntity = (api: ScheduledDeliveryAPIModel): ScheduledDeliveryEntity =>
  ScheduledDeliveryEntity.create({
    uuid: api.uuid,
    sendingScheduleUUID: api.sendingScheduleUUID,
    advertUUID: api.advertUUID,
    channelUUID: api.channelUUID,
    telegramAccountUUID: api.telegramAccountUUID,
    accountId: api.accountId,
    status: api.status,
    jobId: api.jobId,
    plannedAt: new Date(api.plannedAt),
    createdAt: new Date(api.createdAt)
  })

export const mapEntityToDTO = (entity: ScheduledDeliveryEntity): ScheduledDelivery => ({
  uuid: entity.uuid,
  sendingScheduleUUID: entity.sendingScheduleUUID,
  advertUUID: entity.advertUUID,
  channelUUID: entity.channelUUID,
  telegramAccountUUID: entity.telegramAccountUUID,
  accountId: entity.accountId,
  status: entity.status as any,
  jobId: entity.jobId,
  plannedAt: entity.plannedAt.toISOString(),
  createdAt: entity.createdAt.toISOString(),
})
